export default __webpack_public_path__ + "60fddc276b75a5ba93c609bf484e60ab.svg";